import { useSelector } from 'react-redux';

import classes from './FooterBanner.module.css';

const FooterBanner = () => {
  const dataAcademy = useSelector(state => state.academyInfo);

  return (
    dataAcademy.showBanner && (
      <>
        <figure className={classes.footerBannerMovil}>
          <img
            className={classes.img}
            src={dataAcademy.data.footerImageMobile}
          />
        </figure>
        <figure className={classes.footerBannerDesktop}>
          <img
            className={classes.img}
            src={dataAcademy.data.footerImage}
          />
        </figure>
      </>
    )
  );
};

export default FooterBanner;
